import { render, staticRenderFns } from "./StatusArrematante.vue?vue&type=template&id=cb7510ca&"
import script from "./StatusArrematante.vue?vue&type=script&lang=js&"
export * from "./StatusArrematante.vue?vue&type=script&lang=js&"
import style0 from "./StatusArrematante.vue?vue&type=style&index=0&id=cb7510ca&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports